"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_acdc_1 = require("@seaweb/react-acdc");
var DEFAULT_SELECT_WIDTH = 300;
exports.useSelectListWidth = function (widthProp) {
    var getInputElement = react_acdc_1.useAcdcElementRegistryContext().getInputElement;
    var width = widthProp;
    if (widthProp === 'auto') {
        var inputEl = getInputElement();
        width = inputEl ? inputEl.getBoundingClientRect().width : DEFAULT_SELECT_WIDTH;
    }
    return width;
};
